export const theme = {
    color: {
        black: "#000",
        blue: "#0866ff",
        silver: "#656565",
        alto: "#eaeaea",
        gallery: "#eee",
        navigation: "#fff",
        background: "#f6f6f6",
        search: "#f6f6f6",
        sectionShadow: "#eaeaea",
        section: "#fff",
        font: "#1d4368",
        fontOnButton: "#fff",
        white: "#fff",
        teal: "#1d4368",
        footerBackground: "#173552",
        tableBackgroud: "#f8f7f7",
        tableHeader: "#c0c0c0",
        tableBorder: "#d9d9d9",
        tableHover: "#eeeeee",
        hoursBorder: "#eaeaea",
        lessImportant: "#808080",
        brigtherLessImportant: "#f3f3f3",
        crimson: "#a91818",
        forestGreen: "#228c22",
        loader: "#fff",
        headerUnderline: "#808080",
    },
    breakpoint: {
        mobileMax: 1000,
        mobileMax1: 950,
        mobileMax2: 820,
        mobileMax21: 583,
        mobileMax22: 370,
        mobileMax3: 320,
    },
};